import type { OnHoldConfig } from '../../configuration/shared';
import type { FillPathway } from '../../contexts/fill';
import type { PathwayScreen } from '../../hooks/use-config-api';

export const shouldShowHoldButton = (
    onHoldConfig: OnHoldConfig | null,
    pathway: FillPathway | null,
    subPathway: string | null,
    screen: PathwayScreen | undefined
): boolean => {
    if (!onHoldConfig || !onHoldConfig.allowHold) {
        return false;
    }

    const subPathways = onHoldConfig.subPathways ?? [];
    const screens = onHoldConfig.screens ?? [];

    const hasPathwayMatch =
        !!pathway && onHoldConfig.pathways.includes(pathway);

    const hasSubPathwayMatch =
        subPathways.length === 0 ||
        (!!subPathway && subPathways.includes(subPathway));

    const hasScreenMatch =
        screens.length === 0 || (!!screen && screens.includes(screen));

    return hasPathwayMatch && hasSubPathwayMatch && hasScreenMatch;
};
